export default "__VITE_ASSET__yHfjraJn__"